<template>
  <form class="form" @submit.prevent="">
    <div class="form-fields">
      <div class="mb-6 grid grid-cols-2 gap-6">
        <VFormInput
          label="Name*"
          placeholder="Enter name"
          :initialValue="initialValues.name"
          :error="errors.name"
          @update="value => $emit('set', 'name', value)"
        />

        <VFormInput
          label="Phone*"
          placeholder="Enter phone"
          :initialValue="initialValues.phone"
          :error="errors.phone"
          @update="value => $emit('set', 'phone', value)"
        />
      </div>
      <div class="mb-6 grid grid-cols-1 gap-10">
        <VFormInput
          label="Email*"
          placeholder="Enter email"
          :initialValue="initialValues.email"
          :error="errors.email"
          @update="value => $emit('set', 'email', value)"
        />
      </div>
      <div class="mb-6 grid grid-cols-2 gap-10">
        <div>
          <div class="mb-2 -mt-6 text-xs font-semibold">Is Coordinator*</div>
          <div
            v-for="(m, index) in isCoordinatorTypes"
            :key="`is-coordinator-m-${index}`"
            class="pr-4 ratio"
          >
            <input
              class="ratio-input"
              :id="m.name"
              type="radio"
              :value="m.value"
              v-model="isCoordinatorType"
            />
            <label class="ratio-label" :for="m.name"></label>
            <span class="ratio-name">{{ m.name }}</span>
          </div>
        </div>
        <div>
          <VFormSelect
            placeholder="Select Coordinator from list"
            label="Sale Coordinator"
            :options="accountCoordinatorOptions"
            :reset="isCoordinatorType === 1"
            :fullDisabled="isCoordinatorType === 1"
            optionKey="name"
            :initialSelectedOption="initialValues.sales_rep_id"
            :error="errors.sales_rep_id"
            @onSelect="value => $emit('set', 'sales_rep_id', value)"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import VFormInput from '@/components/base/VFormInput';
import VFormSelect from '@/components/base/VFormSelect';

const IS_COORDINATOR_TYPES = [
  { name: 'Yes', value: 1 },
  { name: 'No', value: 0 },
];

export default {
  name: 'SalesRepForm',
  components: { VFormInput, VFormSelect },
  props: {
    accountCoordinator: {
      type: Array,
      required: false,
      default: () => [],
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      isCoordinatorTypes: IS_COORDINATOR_TYPES,
      isCoordinatorType: '',
    };
  },
  watch: {
    isCoordinatorType(isCoordinator) {
      if (isCoordinator) {
        this.$emit('set', 'sales_rep_id', null);
      }
      this.$emit('set', 'is_coordinator', isCoordinator);
    },
  },
  computed: {
    accountCoordinatorOptions() {
      return this.accountCoordinator;
    },
  },
  methods: {},
  created() {
    this.isCoordinatorType =
      this.initialValues.is_coordinator == undefined ? '0' : this.initialValues.is_coordinator;
  },
};
</script>
